export enum UserFlowIds {
  CategoriesCustomisation = "categories_customisation",
  NativePerksHomeExplore = "native_perks_home_explore"
}
